import clsx from "clsx";
import type { GuestTabletDisplayStep } from "@/types/guestTablet";

const STEP_LABELS: Record<GuestTabletDisplayStep, string> = {
  idle: "Bereit",
  welcome: "Willkommen",
  review: "Daten",
  pitch_choice: "Platz",
  guest_guide: "Gästemappe",
  invoice: "Rechnung",
  complete: "Fertig",
};

const WIZARD_STEPS: GuestTabletDisplayStep[] = [
  "review",
  "pitch_choice",
  "guest_guide",
  "invoice",
  "complete",
];

type Props = {
  currentStep: GuestTabletDisplayStep;
};

export function TabletStepNav({ currentStep }: Props) {
  const visible = WIZARD_STEPS.filter(
    (s) => s !== "pitch_choice" || currentStep === "pitch_choice",
  );
  const currentIndex = visible.indexOf(currentStep === "idle" ? "review" : currentStep);

  return (
    <nav aria-label="Fortschritt" className="guest-tablet-step-nav">
      <ol className="flex items-center justify-between gap-2">
        {visible.map((step, index) => {
          const done = currentIndex > index;
          const active = step === currentStep;
          return (
            <li key={step} className="flex min-w-0 flex-1 flex-col items-center gap-1">
              <span
                className={clsx(
                  "flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold",
                  done && "bg-emerald-700 text-white",
                  active && !done && "bg-emerald-700 text-white ring-4 ring-emerald-700/20",
                  !done && !active && "bg-emerald-900/10 text-emerald-900/50 dark:bg-white/10 dark:text-white/40",
                )}
                aria-current={active ? "step" : undefined}
              >
                {done ? "✓" : index + 1}
              </span>
              <span
                className={clsx(
                  "max-w-full truncate text-center text-xs font-medium sm:text-sm",
                  active ? "text-emerald-950 dark:text-emerald-50" : "text-emerald-900/50 dark:text-emerald-100/50",
                )}
              >
                {STEP_LABELS[step]}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
